export var defaultCardHeight = 120;
export var defaultElementsPerPage = 4;
export var defaultMessageHeight = 20;
export var defaultSubjectHeight = 25;
export var defaultLocale = 'ru';
export var defaultPageSize = 10;
export var defaultFilters = {
    sort: [{ created: 'desc' }, { id: 'desc' }],
    pageSize: defaultPageSize,
};
export var notificationColors = {
    card: {
        hover: '#EEF9FF',
        background: '#F5F5F5',
    },
    status: {
        active: '#EB5757',
        border: '#E0E0E0',
    },
};
// Class or id constants for testing.
export var toggleButtonClass = 'notification-toggle-btn';
export var notificationCardClass = 'notification-card';
export var notificationStatusClass = 'notification-status';
export var notificationCardTextClass = 'notification-card__text';
export var notificationCardTitleClass = 'notification-card__title';
export var scrollablePaperId = 'scrollable-paper';
export var deleteNotificationClass = 'delete-notification';
export var endMessageClass = 'end-message';
export var bellIconId = 'bell-icon';
export var notificationsLoader = 'notifications-loader';
export var notificationFooterDate = 'notifications-footer-date';
export var notificationPanelWrapperHeader = 'notifications-panel-wrapper-header';
